import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {
    GuestFormType,
    GuestManagementComponent
} from '@employee-pages/badge-request-page/employee-member-firm-visitor/add-guest/guest-management';
import {AutomaticCroppingService} from '@ui-app/services/automatic-cropping.service';
import {EmployeeBusinessService} from '../../../../core/services/business.service';
import {ImageService} from '@ui-app/services/image.service';
import {IContractorFormGuest, IContractorRequest, IGuestRequest} from '@employee-pages/badge-request-page/usi-employee-badge-forms';
import {IServiceAreaDto, IThirdPartyContractorGuestRequest} from '../../../../../../../DBadgePrehire-app/src/app/models/data.models';
import {REGEX_MOBILE_FORMAT} from '@employee-models/common.enums';
import {IBadgeRequestPhotoInfo, IBloodGroupDto} from '@employee-models/data.models';
import {ISearchEmployeeApprovers} from '@employee-models/common.models';
import { UsersService } from '../../../../core/services/data-access/users.service';
import { PhotoData } from '@shared-models/common.models';
import * as EmployeeModels from '@employee-models/index';
import { UserRoleEnum, BadgeRequestCategoryEnum } from '@employee-models/data.enums';

@Component({
    selector: 'employee-edit-contractor',
    templateUrl: './add-contractor.component.html',
    styleUrls: ['./add-contractor.component.less']
})
export class EditContractorComponent extends GuestManagementComponent implements OnInit {
    @Output() guestEdited = new EventEmitter<any>();
    @Input() guestData: IThirdPartyContractorGuestRequestWithFullApprovers;
    @Input() bloodGroups: IBloodGroupDto[] = [];
    @Output() formDirty = new EventEmitter<boolean>();
    @Input() isBadgeExtension: boolean = false;
    user: any;
    title = 'Edit contractor';
    buttonSubmitTitle = 'Save';
    guestFormType = GuestFormType.EDIT;

    // @ts-ignore
    addGuestForm: FormGroup<IContractorFormGuest>;

    attachmentsList: any[] = [];
    //accessRequiredId: string;
    accessRequiredIds: string[];
    serviceAreas: IServiceAreaDto[] = [];
    selectedServiceArea: string;
    DisplayDate = 180; // Restricted to 180 days for both new requests and badge extensions.
    
    readonly uploadAttachmentConfig = {
        title: 'Upload Attachments',
        button: 'Add',
        areaTitle: 'Drag & Drop files here or',
        customRestrictions: 'You can add up to 10 files with max size 5 MB each <br> Supported formats: PDF, XLS, DOC, PPT, JPEG, JPG, PNG, ZIP',
        maxFilesCount: 10,
        formats: ['JPG', 'PDF', 'XLS', 'DOC', 'PPT', 'JPEG', 'PNG', 'ZIP', 'XLSX'],
        maxFileSize: 5 * 1024 * 1024,
        isAttachment: true,
        isBulkVisitorUpload: false,
        errors: {
            filesCount: 'Maximum 10 files can be uploaded at once',
            faceRecognition: `The photo isn't individual or face isn't clear on the photo. Please, upload another photo`,
        },
    };
    
    constructor(protected fb: FormBuilder,private usersService: UsersService,
                automaticCroppingService: AutomaticCroppingService,
                employeeBusinessService: EmployeeBusinessService,
                imageService: ImageService,
    ) {
        super(fb, automaticCroppingService, employeeBusinessService, imageService);
        this.employeeBusinessService.userProfileService.userData$.subscribe(data => this.user = data);
        }
    
    ngOnInit(): void {
        this.createForm();
        if (this.guestData?.photoInfo && this.guestData.photoInfo['file'] && this.guestData.photoInfo['file'].url) {
            this.userPhotoUrl = this.guestData.photoInfo['file'].url;
            this.photoData = this.guestData.photoInfo['file'];
        }
        
        // Load existing attachments from comma-separated string
        if (this.guestData.attachmentGuid && typeof this.guestData.attachmentGuid === 'string') {
            // For now, just store the string - actual file details would need to be fetched from backend
            // The attachmentsList is used for display, but since we don't have file details here,
            // we'll keep it simple and just let users upload new attachments
            this.attachmentsList = [];
        }
        
        this.setupCropImage();
        this.setupImageResize();
        this.getUserServiceArea();
    }

    createForm(): void {
        // @ts-ignore
        this.addGuestForm = this.fb.group({
            firstName: [this.guestData.firstName, [Validators.required]],
            lastName: [this.guestData.lastName, [Validators.required]],
            phoneNumber: [this.guestData.phoneNumber, [Validators.required, Validators.pattern(REGEX_MOBILE_FORMAT)]],
            serviceAreaId: [this.guestData.serviceAreaId, [Validators.required]],
            serviceAreaName: [this.guestData.serviceAreaName, [Validators.required]],
            agency: [this.guestData.agency, [Validators.required]],
            comment: [this.guestData.comment],
            dateOfJoining: [this.guestData.dateOfJoining, [Validators.required]],
            entityOrFssId: [String(this.guestData.entityOrFssId), [Validators.required]],
            entityOrFssName: [String(this.guestData.entityOrFssName)],
            approvers: [this.guestData.approvers,[Validators.required]],
            approversFull: [this.guestData.approversFull],
            photoInfo: [this.guestData.photoInfo],
            accessRequiredIds: [this.guestData.accessRequiredIds],
            attachmentGuid: [this.guestData.attachmentGuid],
            isBadgeExtension: [(this.guestData as any).isBadgeExtension || false]
        });
        if(this.user.userRoleId == 81)  //UserRoleId==81 is Senior Manager Role as returned from the user API in frontend
            {
                  this.addGuestForm.controls.approvers.clearValidators();
                  this.addGuestForm.updateValueAndValidity();
            }
        this.selectedServiceArea = this.guestData?.serviceAreaName ?? '';

        if (this.guestData?.photoInfo && this.guestData.photoInfo['file'] && this.guestData.photoInfo['file'].url) {
            this.userPhotoUrl = this.guestData.photoInfo['file'].url;
        }
    }
    getUserServiceArea(): void {

        this.subs = this.usersService.getUserServiceAreas().subscribe(data => {
            this.serviceAreas = data;
            if (this.serviceAreas.length === 1) {
                this.addGuestForm.controls.serviceAreaId.setValue(String(this.serviceAreas[0].serviceAreaId));
                this.addGuestForm.controls.serviceAreaName.setValue(String(this.serviceAreas[0].serviceAreaName));
            }
        })
    }
    serviceAreaChanged(serviceArea: string): void {
        this.selectedServiceArea = serviceArea;
        const areaId = this.serviceAreas.find(area => area.serviceAreaName === serviceArea).serviceAreaId;
        this.addGuestForm.controls.serviceAreaId.setValue(areaId.toString());
        this.addGuestForm.controls.serviceAreaName.setValue(serviceArea);
    }

    // @ts-ignore
    editGuest(formValue: IContractorRequest): void {
        formValue = {
            ...this.addGuestForm.value,
            approvers: this.user.userRoleId == 81 ? [this.user.userId] : this.addGuestForm.value.approvers,
            isBadgeExtension: (this.addGuestForm.value as any).isBadgeExtension
        } as unknown as IContractorRequest;
        
        // Set photoInfo={} for badge extensions
        if ((formValue as any).isBadgeExtension) {
            (formValue as any).photoInfo = {};
        }
        
        this.guestEdited.emit(formValue);
        // this.resetForm();
    }

    setApprovers(approverIds: number[]): void {
        const previousApprovers = this.addGuestForm.value.approvers || [];
        this.addGuestForm.patchValue({
            approvers: approverIds
        });
        if (approverIds.length !== previousApprovers.length) {
            this.addGuestForm.markAsDirty();
        }
        this.onFormChange();
    }

    setFullApprovers(approvers: ISearchEmployeeApprovers[]): void {
        const previousApprovers = this.addGuestForm.value.approversFull || [];
        this.addGuestForm.patchValue({
            approversFull: approvers
        });
        if (approvers.length !== previousApprovers.length) {
            this.addGuestForm.markAsDirty();
        }
        this.onFormChange();
    }

    onFormChange() {
        this.formDirty.emit(this.addGuestForm.dirty);
    }

    onAttachmentUpload(event: any[]): void {
        if (event.length > 0) {
            event.forEach(data => {
                const file = this.getFileFromPhotoData(data);
                this.attachmentsList.push(file);
            });
            
            const allGuids = this.attachmentsList.map(file => file.uId).join(',');
            
            this.addGuestForm.patchValue({
                attachmentGuid: allGuids,
            });
        }
    }

    clearAttachment(index?: number): void {
        if (index !== undefined) {
            this.attachmentsList.splice(index, 1);
            
            this.addGuestForm.patchValue({
                attachmentGuid: this.attachmentsList.length > 0 
                    ? this.attachmentsList.map(f => f.uId).join(',')
                    : null,
            });
        } else {
            this.attachmentsList = [];
            this.addGuestForm.patchValue({
                attachmentGuid: null,
            });
        }
    }

    submit(): void {
        this.editGuest(this.addGuestForm.value as IContractorRequest);
    }
}


export interface IThirdPartyContractorGuestRequestWithFullApprovers extends IThirdPartyContractorGuestRequest {
    approversFull?: ISearchEmployeeApprovers[];
    entityOrFssName?: string;
    serviceAreaName?: string;
}
